import jwt from "jsonwebtoken";

export default function sessionTimer(
  setLoggedIn,
  setTokenExpired,
  clearUserTokens,
  tokenExpired
) {
  setInterval(() => {
    const accessToken = localStorage.getItem("Hstm.Identity.AccessToken");
    if (accessToken !== null) {
      const token = jwt.decode(accessToken);

      if (token !== null) {
        if (!tokenExpired && Date.now() >= token.exp * 1000) {
          setLoggedIn(false);
          setTokenExpired(true);
          clearUserTokens();
          window.location.href = window.location.origin;
        }
      }
      if (token === null || token === undefined) {
        clearInterval();
      }
    }
  }, 30000);
}
